import React, { useState, useMemo } from "react";
import {
  Layout,
  Button,
  Modal,
  Tabs,
} from "antd";
import { PlusCircleOutlined } from '@ant-design/icons'
import { StyledTableWrapper } from './styled';
import TemplatesTable from "./TemplatesTable";
import TemplateForm from './TemplateForm';
import { useTemplates } from "./hooks/useTemplates"
import decodeToken from '../../utils/decodeToken';
const { Content } = Layout;

const Templates = ({ isLeadPhysician }) => {
  const [templateType, setTemplateType] = useState('case');
  const [templateModalIsOpen, setTemplateModalIsOpen] = useState(false);

  const user = useMemo(() => {
    const decodedToken = decodeToken(localStorage.getItem('token'));
    return decodedToken?.user;
  }, []);

  const {
    selectTemplate,
    clearTemplates,
    optimisticEdit,
    optimisticDelete,
    setTemplateFilters,
    searchTemplates,
    telemedicineCategories,
    caseStatuses,
    loading,
    templates,
    templateFilters
  } = useTemplates(templateType, user)

  const handleFinish = () => {
    setTemplateModalIsOpen(false)
    selectTemplate(null)
  };

  const handleChangeTemplateType = type => {
    clearTemplates()
    setTemplateType(type)
  }

  const _searchTemplates = () => {
    searchTemplates({ type: templateType, ...templateFilters })
  }

  return (
    <Content>
      <StyledTableWrapper>
        <Tabs
          style={{ display: 'block', height: '100%' }}
          activeKey={templateType}
          onChange={handleChangeTemplateType}
          tabBarExtraContent={
            <Button
              id="template-add-btn"
              type='primary'
              icon={<PlusCircleOutlined />}
              onClick={() => setTemplateModalIsOpen(true)}
            >
              Add
            </Button>
          }
          items={[{
            key: 'case',
            label: 'Case Templates',

            children: <TemplatesTable 
              loading={loading}
              type='case' 
              user={user}
              templates={templates}
              templateFilters={templateFilters}
              telemedicineCategories={telemedicineCategories}
              caseStatuses={caseStatuses}
              setTemplateFilters={setTemplateFilters}
              handleFinish={handleFinish}
              searchTemplates={searchTemplates}
            />
          }, {
            key: 'message',
            label: 'Message Templates',

            children: <TemplatesTable 
              loading={loading}
              type='message' 
              user={user}
              templates={templates}
              templateFilters={templateFilters}
              telemedicineCategories={telemedicineCategories}
              caseStatuses={caseStatuses}
              setTemplateFilters={setTemplateFilters}
              handleFinish={handleFinish}
              searchTemplates={searchTemplates}
            />
          }, isLeadPhysician && {
            key: 'visit',
            label: 'Visit Note Templates',

            children: <TemplatesTable
              loading={loading}
              type='visit'
              user={user}
              templates={templates}
              optimisticEdit={optimisticEdit}
              optimisticDelete={optimisticDelete}
              templateFilters={templateFilters}
              telemedicineCategories={telemedicineCategories}
              caseStatuses={caseStatuses}
              setTemplateFilters={setTemplateFilters}
              handleFinish={handleFinish}
              searchTemplates={searchTemplates}
            />
          }]} />
      </StyledTableWrapper>
      <Modal
        maskClosable
        centered
        closable={false}
        width='50vw'
        footer={null}
        open={templateModalIsOpen}
        onCancel={() => setTemplateModalIsOpen(false)}
      >
        <TemplateForm
          mode='Add'
          type={templateType}
          handleFinish={handleFinish}
          searchTemplates={_searchTemplates}
        />
      </Modal>
    </Content>
  );
};

export default Templates;
